<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY <br/></span>A<span class="smallcaps">LAN </span>P<span class="smallcaps">ARKS</span></h1>
<p class="center"><em class="italic">Bloody January</em></p>
<p class="center"><em class="italic">February’s Son</em></p>
<p class="center"><em class="italic">Bobby March Will Live Forever</em></p>
<p class="center"><em class="italic">The April Dead</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// may-god-forgive_00000.vue?04b188da